/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import ModalChildren from './ModalChildren';

function ModalExecuteAction({ modalIsOpen, setIsOpen, action, text, actionColor, isLoading = false }: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <ModalChildren
        setIsOpen={setIsOpen}
        modalIsOpen={modalIsOpen}
        text={text}
        actionColor={actionColor}
        action={action}
        closeModal={closeModal}
        isLoading={isLoading}
      />
    </ModalBase>
  );
}

export default ModalExecuteAction;
